import classNames from 'classnames';
import { PropsWithChildren } from 'react';

import { CurrencyValue } from '@client/api';

import { FieldWrapper, FieldWrapperEndAdornmentProps } from '../../ui';

export interface CurrencyAdornmentProps {
  currency?: CurrencyValue;
  symbol?: string;
  position?: 'start' | 'end';
  size?: FieldWrapperEndAdornmentProps['size'];
}
export function CurrencyAdornment({
  children,
  currency,
  symbol,
  position = 'end',
  size = 'medium',
}: PropsWithChildren<CurrencyAdornmentProps>) {
  return (
    <FieldWrapper>
      {position === 'start' && (
        <FieldWrapper.StartAdornment size={size}>
          <span className={classNames('text-gray-300', size === 'medium' && 'text-sm', size === 'small' && 'text-xs')}>
            {currency?.symbol || symbol}
          </span>
        </FieldWrapper.StartAdornment>
      )}

      {children}

      {position === 'end' && (
        <FieldWrapper.EndAdornment size={size}>
          <span className={classNames('text-gray-300', size === 'medium' && 'text-sm', size === 'small' && 'text-xs')}>
            {currency?.symbol || symbol}
          </span>
        </FieldWrapper.EndAdornment>
      )}
    </FieldWrapper>
  );
}
